import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import React from 'react'
import { isWindowAtBottom, isAtBottom } from '../../util/scrolling'
import log from '../../util/log'
import { isString } from 'lodash'

export const VERTICAL = 'VERTICAL',
    HORIZONTAL = 'HORIZONTAL',
    getProp = direction => (direction === VERTICAL ? 'scrollTop' : 'scrollLeft')

export default (scrollElementOrSelector = window, direction = VERTICAL) => WrappedComponent =>
    class FetchOnScroll extends React.Component {
        static propTypes = {
            fetchGifs: PropTypes.func.isRequired,
            isOffScreen: PropTypes.bool.isRequired,
            [getProp(direction)]: PropTypes.number.isRequired,
        }

        propToCheck = getProp(direction)
        scrollElement = scrollElementOrSelector
        checkFunction = scrollElementOrSelector === window ? isWindowAtBottom : isAtBottom

        componentDidMount() {
            if (isString(this.scrollElement)) {
                this.scrollElement = document.querySelector(this.scrollElement)
            }
        }

        componentDidUpdate(prevProps) {
            const lastScroll = prevProps[this.propToCheck]
            const scroll = this.props[this.propToCheck]
            const scrollDiff = scroll - lastScroll
            const threshold = Math.max(50, scrollDiff * 3)

            if (
                !this.props.isOffScreen &&
                !this.props.isFetching &&
                this.checkFunction(threshold, this.scrollElement)
            ) {
                log.debug('fetch on scroll')
                this.props.fetchGifs()
            }
        }
        getWrappedComponent() {
            return this.wrappedComponent
        }
        render() {
            return <WrappedComponent {...this.props} ref={c => (this.wrappedComponent = c)} />
        }
    }
